<template>
  <div class="allFilesBox">
    <el-dialog
      title="选择模板文件"
      :visible.sync="dialogVisible"
      width="500px"
      top="10vh"
      custom-class="allFilesDialog"
      @open="open"
      :before-close="beforeClose"
      @closed="closed"
      append-to-body
    >
      <div v-if="!requested || fileList.length == 0" v-loading="!requested" class="empty">
        暂无Excel模板文件
      </div>
      <ul v-else>
        <li
          v-for="(item, index) in fileList"
          :key="index"
          :class="{ active: activeIndex == index }"
          @click="activeIndex = index"
        >
          <img :src="require('~/images/file/xlsx.svg')" alt="xlsx" />
          <span class="name">{{ item.name }}</span>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submit">确 定</el-button>
        <el-button @click="beforeClose">取 消</el-button>
        <el-upload
          action=""
          :before-upload="beforeUpload"
          :http-request="upload"
          :show-file-list="false"
          :accept="accept"
        >
          <el-button type="success" style="margin-left: 10px">
            现在上传
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
          <!-- <el-button size="small" type="primary">点击上传</el-button> -->
        </el-upload>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { randomString, getFileHash, resolveFileName, handleOTAFile } from "@/utils/common"
import * as fileApi from "@/api/userCenter/file"
import { getStsToken } from "@/api/app"
import * as OSS from "@/utils/aliOss"
export default {
  name: "AllFilesDialog",
  props: {
    dialogVisible: Boolean,
    search: {
      type: String,
      default: ""
    },
    accept: {
      type: String,
      default: ""
    },
    uploadCatalogue: {
      type: String,
      default: "sheet-attachment/"
    },
    url_prefix: {
      type: String,
      default: "https://new-service.oss-cn-hangzhou.aliyuncs.com/"
    },
    defaultFileId: String
  },
  data() {
    return {
      requested: false,
      fileList: [],
      activeIndex: -1
    }
  },
  beforeCreate() {
    // 初始化oss
    getStsToken().then(res => {
      let data = {
        ...res.data.data,
        region: "oss-cn-hangzhou",
        bucket: "new-service"
      }
      delete data.expiration
      OSS.createOssClient(data)
    })
  },
  methods: {
    // Dialog 打开的回调
    open() {
      if (!this.requested) this.getAttachmentList()
      else this.setDefaultFile()
    },
    // Dialog 关闭前的回调
    beforeClose() {
      this.$emit("update:dialogVisible", false)
    },
    // Dialog 关闭后的回调
    closed() {
      this.activeIndex = -1
    },
    // 设置默认选中的文件
    setDefaultFile() {
      if (!this.defaultFileId) return
      this.activeIndex = this.fileList.findIndex(i => i.id == this.defaultFileId)
    },
    // 获取文件列表
    getAttachmentList() {
      return fileApi
        .getAttachmentList({ search: this.search, size: 100 })
        .then(res => {
          this.fileList = res.data.data.content
          this.setDefaultFile()
        })
        .catch(err => {
          this.$message.error("数据请求失败，请刷新后重试！")
        })
        .finally(() => {
          setTimeout(() => {
            this.requested = true
          }, 300)
        })
    },
    // 提交选中的文件
    submit() {
      if (this.activeIndex == -1) this.$emit("submit", null)
      else this.$emit("submit", this.fileList[this.activeIndex])
      this.beforeClose()
    },
    // 上传文件前
    beforeUpload(file) {
      if (this.accept && this.accept.indexOf(file.type) == -1) {
        this.$message.error({
          message: "上传文件类型错误，请重新选择",
          offset: 100
        })
        return false
      }
    },
    // 上传文件
    async upload(params) {
      let file = params.file
      let { ext } = resolveFileName(file.name)
      let hasUploaded = {
        status: false,
        uploadPath: ""
      }
      let res = null

      try {
        // 获取文件hash，若是OTA文件(.bin)，则移除文件末尾 hash 信息
        if (ext == "bin") {
          res = await handleOTAFile(file)
          if (!res.result) return this.uploadFileError(file, "文件校验失败！")
          file = res.file // 移除 hash 信息后的文件
        } else {
          file.hash = await getFileHash(file)
        }
        // 检查是否已经上传过了
        res = await fileApi.checkAttachment(file.hash)
        if (res.data.data) {
          hasUploaded = {
            status: true,
            uploadPath: res.data.data
          }
        }
      } catch (error) {
        return this.uploadFileError(file)
      }

      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)"
      })

      // 设置文件的一些信息
      let uploadFileName = file.uid + "_" + randomString(8) + "_" + file.name
      let uploadPath = this.uploadCatalogue + uploadFileName
      file.uploadFileName = uploadFileName
      file.status = "uploading"
      file.sizeStr = this.getFileSize(file.size)
      let fileInfo = { name: file.name, sizeByte: file.size, ...file }
      fileInfo.type = file.type ? file.type : ext

      // 上传OSS，已上传文件不再上传
      let ossRes
      if (!hasUploaded.status) {
        ossRes = await this.uploadToOss(file, uploadPath, fileInfo)
        if (!ossRes) {
          loading.close()
          return
        }
      }

      // 回传服务器
      fileApi
        .uploadAttachment({
          name: fileInfo.name,
          path: hasUploaded.status ? hasUploaded.uploadPath : uploadPath,
          sizeStr: fileInfo.sizeStr,
          sizeByte: fileInfo.sizeByte,
          type: fileInfo.type,
          hash: fileInfo.hash
        })
        .then(res => {
          if (res.data.code != 0) {
            return this.uploadFileError(fileInfo)
          } else {
            fileInfo.id = res.data.data.id
            fileInfo.url = hasUploaded.status
              ? this.url_prefix + hasUploaded.uploadPath
              : ossRes.url
            fileInfo.status = "success"
            let length = this.fileList.push(fileInfo)
            this.activeIndex = length - 1
          }
        })
        .catch(err => {
          this.uploadFileError(fileInfo)
        })
        .finally(() => {
          setTimeout(() => {
            loading.close()
          }, 200)
        })
      return
    },
    // 上传错误
    uploadFileError(fileInfo, message = "文件上传失败,请重试！") {
      fileInfo.status = "failure"
      this.$message.error({ message, offset: 100 })
    },
    // 上传OSS
    async uploadToOss(file, uploadPath, fileInfo) {
      let ossRes
      let headers = {
        "Cache-Control": "public, max-age=31536000"
      }
      // 大于10MB使用断点续传
      if (file.size > 10485760) {
        try {
          ossRes = await OSS.resumeUpload(uploadPath, file, {
            headers,
            partSize: 10485760
          })
          if (ossRes.res.status != 200) {
            this.uploadFileError(fileInfo)
            return false
          }
        } catch (err) {
          this.uploadFileError(fileInfo)
          return false
        }
      }
      // 普通上传
      else {
        try {
          ossRes = await OSS.put(uploadPath, file, {
            headers
          })
          if (ossRes.res.status != 200) {
            this.uploadFileError(fileInfo)
            return false
          }
        } catch (err) {
          this.uploadFileError(fileInfo)
          return false
        }
      }
      return ossRes
    },
    // 获取文件的大小
    getFileSize(fileSize) {
      let level = 0
      let units = ["B", "KB", "MB", "GB", "TB"]
      let size = fileSize
      while (size > 1024) {
        size = size / 1024
        level++
      }
      return size.toFixed(2) + units[level]
    }
  }
}
</script>

<style lang="scss" scoped>
.allFilesDialog {
  .empty {
    line-height: 120px;
    margin-bottom: 20px;
    text-align: center;
  }
  ul {
    margin: 20px 0;
    padding: 0;
    list-style-type: none;
    color: #333;
    user-select: none;
    li {
      box-sizing: border-box;
      padding-left: 14px;
      height: 46px;
      line-height: 46px;
      cursor: pointer;
      display: inline-block;
      width: 100%;
      .name {
        margin-left: 10px;
      }
      img {
        height: 32px;
        width: 29px;
        vertical-align: middle;
      }
      &:hover {
        background-color: #f8f8f8;
      }
      &.active {
        background-color: #bbdefb;
      }
    }
  }
}
</style>

<style lang="scss">
.allFilesBox {
  font-size: 13px;
  .el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    .el-dialog {
      margin-bottom: 50px;
      border-radius: 8px;
    }
  }
  .el-dialog__header {
    padding: 20px 24px 18px;
  }
  .el-dialog__body {
    margin-top: 0;
    overflow: auto;
    padding: 0 22px;
    color: #9e9e9e;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
</style>
